/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import {
  faCheck,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import ViewFullReview from "./ViewFullReview";
import { loadApplicantReviews } from "../../actions/agencyProfileActions";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import {
  Wrapper,
  Review,
  Top,
  Info,
  Name,
  Date,
  StarRating,
  FillRating,
  EmptyRating,
  Stars,
  Text,
  ReadMore,
  PaginationButtons,
  PrevButtonWrapper,
  PrevButton,
  NextButtonWrapper,
  NextButton,
  VerifiedBadgeWrapper,
  VerifiedBadge,
} from "./styles/reviews-styles";

export class ApplicantReviews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromIndex: 0,
      toIndex: 3,
      currentPage: 1,
      perPageCount: 3,
      fullReview: false,
      fullReviewData: null,
    };
  }

  componentDidMount() {
    const { currentPage, perPageCount } = this.state;
    const { loadApplicantReviews, recruiterId } = this.props;

    loadApplicantReviews(recruiterId, currentPage, perPageCount);
  }

  handleTextLength = (text) => {
    if (text.length > 200) {
      return `"${text.slice(0, 200)}..."${" "}`;
    }
    return `"${text}..."`;
  };

  handlePrevButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const nextPage = currentPage - 1;
    const { loadApplicantReviews, recruiterId } = this.props;

    loadApplicantReviews(recruiterId, nextPage, perPageCount);
    this.setState({
      fromIndex: fromIndex - perPageCount,
      toIndex: toIndex - perPageCount,
      currentPage: nextPage,
    });
  };

  handleNextButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const nextPage = currentPage + 1;
    const { loadApplicantReviews, recruiterId } = this.props;

    loadApplicantReviews(recruiterId, nextPage, perPageCount);
    this.setState({
      fromIndex: fromIndex + perPageCount,
      toIndex: toIndex + perPageCount,
      currentPage: nextPage,
    });
  };

  handleReadMore = (review) => {
    const { fullReview } = this.state;
    this.setState({
      fullReview: !fullReview,
      fullReviewData: review,
    });
  };

  render() {
    const { applicantReviews, applicantReviewsTotal, reviewsLoading } =
      this.props;
    const { currentPage, fullReview, fullReviewData, perPageCount } =
      this.state;
    const displayedReviewsCount = currentPage * perPageCount;

    if (applicantReviews.length > 0) {
      return (
        <Wrapper>
          {reviewsLoading && <WidgetLoading />}
          {fullReview && (
            <ViewFullReview
              review={fullReviewData}
              revieweeName={fullReviewData.candidateFirstName}
              average={fullReviewData.averageOutOfOneHundred}
              handleClose={this.handleReadMore}
            />
          )}
          {applicantReviews.map((review) => (
            <Review key={review.id}>
              <Top>
                <Info>
                  <Name data-test-id="review-candidate-name">
                    {review.candidateFirstName}
                    <VerifiedBadgeWrapper
                      data-tip="Verified"
                      data-for="agency-profile-tooltip"
                      data-test-id="verified-badge-wrapper"
                    >
                      <VerifiedBadge>
                        <FontAwesomeIcon icon={faCheck} />
                      </VerifiedBadge>
                    </VerifiedBadgeWrapper>
                  </Name>
                  <Date data-test-id="review-created-at">
                    {review.createdAt}
                  </Date>
                </Info>
                <StarRating>
                  <FillRating
                    style={{ width: `${review.averageOutOfOneHundred}%` }}
                  >
                    <Stars>★★★★★</Stars>
                  </FillRating>
                  <EmptyRating>
                    <Stars>★★★★★</Stars>
                  </EmptyRating>
                </StarRating>
              </Top>
              <Text data-test-id="review-message">
                {this.handleTextLength(review.message)}
                {review.message.length > 200 && (
                  <ReadMore onClick={() => this.handleReadMore(review)}>
                    read more
                  </ReadMore>
                )}
              </Text>
            </Review>
          ))}
          <PaginationButtons>
            <PrevButtonWrapper>
              {currentPage > 1 && (
                <PrevButton onClick={this.handlePrevButton}>
                  <FontAwesomeIcon icon={faChevronLeft} /> prev
                </PrevButton>
              )}
            </PrevButtonWrapper>
            <NextButtonWrapper>
              {displayedReviewsCount < applicantReviewsTotal && (
                <NextButton onClick={this.handleNextButton}>
                  next <FontAwesomeIcon icon={faChevronRight} />
                </NextButton>
              )}
            </NextButtonWrapper>
          </PaginationButtons>
        </Wrapper>
      );
    }
    return <Wrapper noReviews>no reviews yet</Wrapper>;
  }
}

ApplicantReviews.propTypes = {
  loadApplicantReviews: PropTypes.func.isRequired,
  recruiterId: PropTypes.string.isRequired,
  applicantReviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  applicantReviewsTotal: PropTypes.number.isRequired,
  reviewsLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  recruiterId: state.agencyProfile.profileData.user.companyId,
  applicantReviews: state.agencyProfile.profileData.applicantReviews,
  applicantReviewsTotal: state.agencyProfile.profileData.applicantReviewsTotal,
  reviewsLoading: state.agencyProfile.reviewsLoading,
});

export default connect(mapStateToProps, { loadApplicantReviews })(
  ApplicantReviews
);
